import canonicalLogo from "@/assets/images/logos/canonical-logo.svg";
import deloitteLogo from "@/assets/images/logos/deloitte-logo.svg";
import justEatLogo from "@/assets/images/logos/just-eat-logo.svg";
import lufthansaLogo from "@/assets/images/logos/lufthansa-logo.svg";
import morningstarLogo from "@/assets/images/logos/morningstar-logo.svg";
import orangeLogo from "@/assets/images/logos/orange-logo.svg";
import rocheLogo from "@/assets/images/logos/roche-logo.svg";
import unicefLogo from "@/assets/images/logos/unicef-logo.svg";
import volkswagenLogo from "@/assets/images/logos/volkswagen-logo.svg";

const COMPANY_LOGOS = [
  { src: rocheLogo, alt: "Roche" },
  { src: morningstarLogo, alt: "Morningstar" },
  { src: lufthansaLogo, alt: "Lufthansa" },
  { src: justEatLogo, alt: "Just Eat" },
  { src: deloitteLogo, alt: "Deloitte" },
  { src: unicefLogo, alt: "UNICEF" },
  { src: volkswagenLogo, alt: "Volkswagen" },
  { src: orangeLogo, alt: "Orange" },
  { src: canonicalLogo, alt: "Canonical" },
];

export const TrustBadges = () => {
  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <p className="text-sm">
          Trusted by customers from <span className="font-semibold">60+ countries</span>
        </p>
      </div>

      <div className="grid grid-cols-3 gap-3 sm:gap-4 xl:gap-6 items-center justify-items-center opacity-90">
        {COMPANY_LOGOS.map((logo) => (
          <div key={logo.alt} className="flex items-center justify-center w-full">
            <img
              src={logo.src}
              alt={logo.alt}
              className="h-8 sm:h-10 lg:h-12 w-auto max-w-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
